import React, { useEffect } from "react";
import { privSnack } from "../../utils";
import "./Snackbar.scss";

export const Snackbar = ({ label, icon }) => {
  const myRef = React.createRef();

  useEffect(() => {
    if (myRef.current) {
      myRef.current.className = "show";
      setTimeout(function () {
        if (myRef.current) myRef.current.className = "";
        localStorage.setItem(privSnack, false);
      }, 3000);
    }
  }, [myRef]);

  return (
    <>
      <div id="snackbar" ref={myRef}>
        {icon ? <img src={icon} alt="icon" /> : null}
        {label ? <span>{label}</span> : null}
      </div>
    </>
  );
};
